export const apiTest = async () => {
  const response = await fetch(`${import.meta.env.VITE_API_URL}/api`, {
    method: "GET",
  });
  if (response.ok) {
    const data = await response.json();
    console.log(data); // JSON 응답 객체를 출력합니다.
  } else {
    console.error("HTTP error", response.status);
  }
};

export const apiUploadPicture = async (
  file: File,
  token: string,
): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/profile/uploadImage`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(`Image upload failed(${response.statusText})`);
    }
    const result = await response.json();
    console.log("Upload successful:", result);
    return result;
  } catch (error) {
    console.error("Error upload profile image:", error);
    throw error;
  }
};

export const apiRegisterSubscription = async (
  payload: {
    deviceId: string;
    subscription: PushSubscription;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/subscription/register`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiRegisterSubscription is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiRegisterSubscription successful:", result);
    return result;
  } catch (error) {
    console.error("apiRegisterSubscription Error:", error);
    throw error;
  }
};

export const apiDeleteSubscription = async (
  payload: {
    deviceId: string;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/subscription/delete`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiDeleteSubscription is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiDeleteSubscription successful:", result);
    return result;
  } catch (error) {
    console.error("apiDeleteSubscription Error:", error);
    throw error;
  }
};

export const apiGetSubscriptions = async (token: string): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/subscription/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiGetSubscriptions is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiGetSubscriptions successful:", result);
    return result;
  } catch (error) {
    console.error("apiGetSubscriptions Error:", error);
    throw error;
  }
};

export const apiPushSend = async (
  payload: {
    userId: string;
    title: string;
    body: string;
    data?: any;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/subscription/send`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiPushSend is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiPushSend successful:", result);
    return result;
  } catch (error) {
    console.error("apiPushSend Error:", error);
    throw error;
  }
};

export const apiGetNotifications = async (
  payload: {
    page: number;
    limit: number;
  },
  token: string,
): Promise<any> => {
  try {
    const offset = (payload.page - 1) * payload.limit;
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/notification/list?limit=${payload.limit}&offset=${offset}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiGetNotifications is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiGetNotifications successful:", result);
    return result;
  } catch (error) {
    console.error("apiGetNotifications Error:", error);
    throw error;
  }
};

export const apiGetNotificationCount = async (token: string): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/notification/count`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiGetNotificationCount is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiGetNotificationCount successful:", result);
    return result;
  } catch (error) {
    console.error("apiGetNotificationCount Error:", error);
    throw error;
  }
};

export const apiReadAllNotification = async (token: string): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/notification/read-all`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiReadAllNotification is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiReadAllNotification successful:", result);
    return result;
  } catch (error) {
    console.error("apiReadAllNotification Error:", error);
    throw error;
  }
};

export const apiReadNotification = async (
  payload: {
    notificationId: string;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/notification/read`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiReadNotification is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiReadNotification successful:", result);
    return result;
  } catch (error) {
    console.error("apiReadNotification Error:", error);
    throw error;
  }
};

export const apiDeleteNotification = async (
  payload: {
    notificationId: string;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/notification/delete`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiDeleteNotification is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiDeleteNotification successful:", result);
    return result;
  } catch (error) {
    console.error("apiDeleteNotification Error:", error);
    throw error;
  }
};

export const apiGetReadMessages = async (token: string): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/readmessage/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiGetReadMessages is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiGetReadMessages successful:", result);
    return result;
  } catch (error) {
    console.error("apiGetReadMessages Error:", error);
    throw error;
  }
};

export const apiUpdateReadMessage = async (
  payload: {
    chatId: string;
    messageId: string;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/readmessage/update`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiUpdateReadMessage is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiUpdateReadMessage successful:", result);
    return result;
  } catch (error) {
    console.error("apiUpdateReadMessage Error:", error);
    throw error;
  }
};

export const fetchGistData = async (gistId: string) => {
  const response = await fetch(`https://api.github.com/gists/${gistId}`);
  const data = await response.json();
  return data;
};

// Raw 콘텐츠 직접 가져오기
export const fetchGistRawContent = async (gistId: string) => {
  const gist = await fetchGistData(gistId);
  const firstFile = Object.values(gist.files)[0];
  //@ts-ignoreq
  const rawUrl = firstFile.raw_url;
  const response = await fetch(rawUrl);
  return response.json();
};
